const invoiceFilters = [
  {
    type: 'text',
    id: 'customer__name',
    label: 'Cliente',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'date',
    label: 'Fecha',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'text',
    id: 'due_date',
    label: 'Fecha de vencimiento',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'numeric',
    id: 'total',
    label: 'Total',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'numeric',
    id: 'number',
    label: 'Número',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'select',
    id: 'document',
    label: 'Tipo de factura',
    choices: []
  },
  {
    type: 'select',
    id: 'collection_method',
    label: 'Forma de pago',
    choices: [
      {label: 'Contado', value: 'automatically'},
      {label: 'Crédito', value: 'deferred'}
    ]
  },
  {
    type: 'radio',
    id: 'subscription__isnull',
    label: 'Suscripción',
    choices: [
      {label: 'Si', value: 'False'},
      {label: 'No', value: 'True'}
    ]
  },
  {
    type: 'radio',
    id: 'credit_note__isnull',
    label: 'Tiene nota de crédito',
    choices: [
      {label: 'Si', value: 'False'},
      {label: 'No', value: 'True'}
    ]
  },
  {
    type: 'select',
    id: 'payments__source__gateway',
    label: 'Procesador de pagos',
    choices: [
      { label: 'Stripe', value: 'stripe' },
      { label: 'Paypal', value: 'paypal' },
      { label: 'OneClick', value: 'oneclick' },
      { label: 'WebPay', value: 'webpay' },
      { label: 'Khipu', value: 'khipu' },
      { label: 'Mercado Pago', value: 'mercadopago' },
      { label: '2Checkout', value: 'twocheckout' },
      { label: 'Pago externo', value: 'offline_payment' },
      { label: 'Transferencia', value: 'ach_transfer' }
    ]
  },
  {
    type: 'select',
    id: 'status',
    label: 'Estado',
    choices: [
      { label: 'Borrador', value: 'draft' },
      { label: 'Por cobrar', value: 'finalized' },
      { label: 'Pagado', value: 'paid' },
      { label: 'Cancelado', value: 'cancelled' },
      { label: 'Incobrable', value: 'uncollectible' }
    ]
  }
]

const paymentFilters = [
  {
    type: 'select',
    id: 'source__gateway',
    label: 'Proveedor de pagos',
    choices: [
      { label: 'Stripe', value: 'stripe' },
      { label: 'Paypal', value: 'paypal' },
      { label: 'OneClick', value: 'oneclick' },
      { label: 'WebPay', value: 'webpay' },
      { label: 'Khipu', value: 'khipu' },
      { label: 'Mercado Pago', value: 'mercadopago' },
      { label: '2Checkout', value: 'twocheckout' },
      { label: 'Pago externo', value: 'offline_payment' },
      { label: 'Transferencia', value: 'ach_transfer' }
    ]
  },
  {
    type: 'radio',
    id: 'customer__isnull',
    label: 'Cliente',
    choices: [
      { label: 'Si', value: 'False' },
      { label: 'No', value: 'True' }
    ]
  },
  {
    type: 'text',
    id: 'customer__name',
    label: 'Nombre del cliente',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'invoice__number',
    label: 'Nº de factura',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'date',
    label: 'Fecha',
    operators: ['es igual', 'es menor a', 'es mayor a'],
    isDate: true
  },
  {
    type: 'text',
    id: 'payment_date',
    label: 'Fecha de pago',
    operators: ['es menor a', 'es mayor a'],
    isDate: true
  },
  {
    type: 'numeric',
    id: 'amount',
    label: 'Monto',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'select',
    id: 'status',
    label: 'Estado',
    choices: [
      { label: 'Pagado', value: 'succeeded' },
      { label: 'Incompleto', value: 'requires_payment_method' },
      { label: 'Fallido', value: 'failed' },
      { label: 'Cancelado', value: 'cancelled' },
      { label: 'Procesando', value: 'processing' }
    ]
  }
]

const creditNoteFilters = [
  {
    type: 'text',
    id: 'invoice__customer__name',
    label: 'Cliente',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'date',
    label: 'Fecha',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'numeric',
    id: 'number',
    label: 'Número',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'select',
    id: 'document',
    label: 'Tipo de nota de crédito',
    choices: []
  },
  {
    type: 'text',
    id: 'note',
    label: 'Nota',
    operators: ['contiene']
  },
  {
    type: 'numeric',
    id: 'total',
    label: 'Total',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'numeric',
    id: 'invoice__number',
    label: 'Número de la factura',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'text',
    id: 'invoice__date',
    label: 'Fecha de la factura',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'select',
    id: 'invoice__document',
    label: 'Tipo de factura asociada',
    choices: []
  },
  {
    type: 'select',
    id: 'invoice__collection_method',
    label: 'Forma de pago de la factura',
    choices: [
      { label: 'Contado', value: 'automatically' },
      { label: 'Crédito', value: 'deferred' }
    ]
  },
  {
    type: 'radio',
    id: 'invoice__subscription__isnull',
    label: 'La factura es por suscripción',
    choices: [
      { label: 'Si', value: 'False' },
      { label: 'No', value: 'True' }
    ]
  }
]

const transfersFilters = [
  {
    type: 'text',
    id: 'description',
    label: 'Descripción',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'date',
    label: 'Fecha',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'numeric',
    id: 'amount',
    label: 'Monto',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'numeric',
    id: 'balance',
    label: 'Monto por conciliar',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'select',
    id: 'status',
    label: 'Estado',
    choices: [
      { label: 'Pendiente', value: 'pending' },
      { label: 'Conciliado', value: 'finalized' },
      { label: 'Archivado', value: 'archived' }
    ]
  }
]

const usagesFilters = [
  {
    type: 'text',
    id: 'date_time',
    label: 'Marca de tiempo',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'numeric',
    id: 'quantity',
    label: 'Cantidad',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'text',
    id: 'subscription_line__subscription__customer__name__icontains',
    label: 'Cliente',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'subscription_line__plan__name',
    label: 'Plan',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'subscription_line__subscription',
    label: 'Suscripción',
    placeholder: 'sub_qwertyuiopasdf',
    operators: ['contiene']
  }
]

const supportingDocumentsFilters = [
  {
    type: 'text',
    id: 'customer__name',
    label: 'Cliente',
    operators: ['contiene']
  },
  {
    type: 'text',
    id: 'serial',
    label: 'Número',
    operators: ['contiene', 'es igual']
  },
  {
    type: 'text',
    id: 'date_issued',
    label: 'Fecha de emisión',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'text',
    id: 'valid_until',
    label: 'Fecha de vencimiento',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'text',
    id: 'due_date',
    label: 'Vencimiento de solicitud',
    operators: ['es igual', 'es menor a', 'es mayor a']
  },
  {
    type: 'select',
    id: 'submission_type',
    label: 'Tipo de solicitud',
    choices: [
      { label: 'Orden de compra', value: 'order' },
      { label: 'HES', value: 'hes' }
    ]
  },
  {
    type: 'select',
    id: 'document_type',
    label: 'Tipo de documento',
    choices: [
      { label: 'Orden de compra', value: '801' },
      { label: 'Contrato', value: '802' }
    ]
  }
]

export {
  creditNoteFilters,
  invoiceFilters,
  paymentFilters,
  transfersFilters,
  usagesFilters,
  supportingDocumentsFilters
}